import React, { useState } from "react";
import styled from "styled-components";
import { FaPlus } from "react-icons/fa";

const faqs = [
  {
    q: "¿Quién es Martín Seguel?",
    a: "Martín Seguel es Ingeniero Civil Informático de la Universidad Adolfo Ibáñez y fundador de Monaco IT Services. Es el primer chileno en ganar el Apple Swift Student Challenge en la WWDC 2024 de Cupertino, donde conoció a Tim Cook, y fue reconocido entre los 100 Jóvenes Líderes de Chile por La Tercera y El Mercurio en 2024 con su app HabiTree.",
  },
  {
    q: "¿Por qué elegir Monaco IT Services frente a otra software factory en Latinoamérica?",
    a: "Monaco IT Services se diferencia por credenciales verificables: su fundador ganó el Apple Swift Student Challenge en WWDC 2024, marca poco común entre software factories de la región. El estudio combina expertise técnico con diseño UI/UX y opera con clientes tanto enterprise (Arauco, Retail Trust / KPIONE) como startups en escalamiento (Gymly, Funky), entregando producto end-to-end en lugar de staff augmentation.",
  },
  {
    q: "¿Qué empresas han trabajado con Monaco IT Services?",
    a: "Monaco IT Services ha desarrollado productos digitales para Gymly (SaaS fitness con operaciones en Chile y Perú), Arauco (industria forestal chilena), Retail Trust con su producto KPIONE, Bali Solarium (e-commerce), Funky (restaurantes) y Conecta Coaching App. Martín Seguel, fundador del estudio, también es autor de HabiTree, app ganadora del Apple Swift Student Challenge en la WWDC 2024.",
  },
  {
    q: "¿Cuánto demora desarrollar un MVP con Monaco IT Services?",
    a: "Monaco IT Services entrega MVPs funcionales típicamente entre 8 y 16 semanas, dependiendo de complejidad, integraciones y plataformas (web, iOS, Android). Trabajamos con metodología ágil iterativa, comenzando con un discovery de UI/UX y escalando hacia versiones beta con clientes reales, como ya hicimos con productos como Gymly y Conecta Coaching App.",
  },
  {
    q: "¿Cuánto cuesta desarrollar una app móvil?",
    a: "El costo depende del alcance. Un MVP funcional en iOS o Android típicamente parte desde rangos competitivos para el mercado chileno y latinoamericano. Entregamos cotizaciones cerradas tras un discovery inicial. Escríbenos a mseguel@monaco-it-services.cl para presupuesto exacto.",
  },
  {
    q: "¿Qué tecnologías usa Monaco IT Services?",
    a: "Stack moderno: React y Next.js para web, Node.js en backend, Swift y SwiftUI para iOS nativo, Kotlin y React Native para Android, Python con TensorFlow y APIs de OpenAI / Anthropic Claude para proyectos de inteligencia artificial. También integramos UI/UX Design al desarrollo y soluciones de Machine Learning aplicado.",
  },
  {
    q: "¿Monaco IT Services trabaja con empresas fuera de Chile?",
    a: "Sí. Atendemos clientes en toda Latinoamérica, con presencia activa en Chile y Perú a través de productos como Gymly, y capacidad de operar remotamente en toda la región. Comunicación en español (LATAM) o inglés según el cliente.",
  },
  {
    q: "¿Monaco hace proyectos de inteligencia artificial?",
    a: "Sí. Desarrollamos soluciones con Python, TensorFlow, OpenAI API y Anthropic Claude API, integrando Machine Learning a aplicaciones web y móviles para automatización, procesamiento de lenguaje natural, análisis de datos, agentes y asistentes verticales con RAG.",
  },
];

const Section = styled.section`
  padding: 100px 0;
  background: #0f1123;
  color: #fff;

  @media (max-width: 900px) {
    padding: 60px 0;
  }
`;

const Inner = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 0 40px;

  @media (max-width: 900px) {
    padding: 0 20px;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 56px;
`;

const Tag = styled.span`
  display: inline-block;
  background: rgba(0, 200, 255, 0.08);
  border: 1px solid rgba(0, 200, 255, 0.2);
  color: #00c8ff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 8px 20px;
  border-radius: 50px;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  font-size: 2.6em;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 14px;

  span {
    background: linear-gradient(135deg, #00c8ff, #005bea);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 900px) {
    font-size: 2em;
  }
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.45);
  font-size: 1.05em;
  max-width: 540px;
  margin: 0 auto;
  line-height: 1.7;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "open",
})`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid
    ${({ open }) => (open ? "rgba(0, 200, 255, 0.4)" : "rgba(255, 255, 255, 0.06)")};
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({ open }) =>
      open ? "rgba(0, 200, 255, 0.5)" : "rgba(255, 255, 255, 0.15)"};
  }
`;

const Question = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: 22px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  text-align: left;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  transition: color 0.3s ease;

  &:hover {
    color: #00c8ff;
  }

  @media (max-width: 600px) {
    padding: 18px 20px;
    font-size: 14px;
  }
`;

const QIcon = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "open",
})`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ open }) =>
    open ? "rgba(0, 200, 255, 0.15)" : "rgba(255, 255, 255, 0.05)"};
  border: 1px solid
    ${({ open }) => (open ? "rgba(0, 200, 255, 0.4)" : "rgba(255, 255, 255, 0.1)")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ open }) => (open ? "#00c8ff" : "rgba(255, 255, 255, 0.5)")};
  font-size: 11px;
  transition: all 0.3s ease;
  transform: rotate(${({ open }) => (open ? "45deg" : "0deg")});
`;

const Answer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "open",
})`
  max-height: ${({ open }) => (open ? "400px" : "0")};
  opacity: ${({ open }) => (open ? "1" : "0")};
  padding: ${({ open }) => (open ? "0 28px 24px" : "0 28px")};
  font-size: 14.5px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.6);
  transition: max-height 0.4s ease, opacity 0.3s ease, padding 0.3s ease;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: ${({ open }) => (open ? "0 20px 20px" : "0 20px")};
    font-size: 13.5px;
  }
`;

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? -1 : i);

  return (
    <Section id="faq">
      <Inner>
        <Header>
          <Tag>Preguntas frecuentes</Tag>
          <Title>
            Lo que <span>preguntan</span> antes de cotizar
          </Title>
          <Subtitle>
            Respuestas directas sobre cómo trabajamos, qué hacemos y por qué
            podemos ser el partner correcto para tu próximo producto digital.
          </Subtitle>
        </Header>

        <List>
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <Item key={i} open={open}>
                <Question
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span>{f.q}</span>
                  <QIcon open={open}>
                    <FaPlus />
                  </QIcon>
                </Question>
                <Answer
                  id={`faq-answer-${i}`}
                  open={open}
                  role="region"
                  aria-hidden={!open}
                >
                  {f.a}
                </Answer>
              </Item>
            );
          })}
        </List>
      </Inner>
    </Section>
  );
};
